function Button({ 
    children, 
    onClick, 
    variant = 'primary', 
    size = 'medium',
    type = 'button',
    disabled = false,
    className = '',
    ...props 
}) {
    const baseClass = 'gw-button';
    const variantClass = `gw-button--${variant}`;
    const sizeClass = `gw-button--${size}`;
    const disabledClass = disabled ? 'gw-button--disabled' : '';
    
    const buttonClass = [
        baseClass,
        variantClass,
        sizeClass,
        disabledClass,
        className
    ].filter(Boolean).join(' ');

    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled}
            className={buttonClass}
            {...props}
        >
            {children}
        </button>
    );
}

export default Button;
